<template>
  <v-simple-table>
    <tbody>
      <Row title="Client Number"          :code="customer.partnerIdentifier" v-if="customer.partnerIdentifier" />
      <Row title="Name"                   :text="customer.name" bold="true" v-if="customer.name" />
      <Row title="Telephone">
        <Telephone :msisdn="customer.msisdn" />
        <span v-if="customer.alternativeMsisdn">&nbsp;/&nbsp;</span>
        <Telephone :msisdn="customer.alternativeMsisdn" v-if="customer.alternativeMsisdn" />
      </Row>
      <Row title="Identity"               :text="customer.demographic.identity.number"  />
      <Row title="Married"                :status="(customer.demographic.maritalStatus ? 'Yes' :  'No')"     v-if="customer.demographic" />
      <Row title="Gender"                 :gender="customer.demographic.gender"                              v-if="customer.demographic" />
      <Row title="Date Of Birth"          :date="customer.demographic.birthdate" v-if="customer.demographic"></Row>
      <Row title="Can Lend"               :status="(customer['doNotLend?'] ? 'No' : 'Yes')" ></Row>
      <Row title="Fingerprint Status"     :text="customer.demographic['isFingerprintEnrolled?'] ? 'Enrolled' : 'Not Enrolled'"     v-if="customer.demographic"                       />


      <Row title="Income"                 :currency="parseInt(customer.economic.icome)"                      v-if="customer.economic && customer.economic.icome"           />
      <Row title="Net Pay"                :currency="parseInt(customer.economic.nettPay)"                    v-if="customer.economic && customer.economic.nettPay"         />
      <Row title="Adjusted Net Income"    :currency="parseInt(customer.economic.adjustedNettPay)"            v-if="customer.economic && customer.economic.adjustedNettPay" />

      <Row title="Employer"               :text="customer.employer.name"                                     v-if="customer.employer && customer.employer.name"          />
      <Row title="Department"             :text="customer.employer.department"                               v-if="customer.employer && customer.employer.department"    />
      <Row title="Payroll Day"            :text="customer.employer.payload.payrollDay"                       v-if="customer.employer && customer.employer.payload && customer.employer.payload.payrollDay"    />
      <Row title="Ultimate Branch"        :code="customer.depot.name"                                        v-if="customer.depot && customer.depot.name"/>
      <Row title="Customers Cached" >
        <v-icon dense small @click='reloadCustomers'>mdi-refresh</v-icon>
      </Row>
      <Row title="" v-if="customer['readOnly'] === false || customer['readOnly'] === null">
        <v-btn color="primary" dense small :to="{ query: { uuid: uuid }, name: 'CreateContact' }">
          <v-icon small left>mdi-account-edit</v-icon>
          Edit
        </v-btn>
      </Row>
      <Row title="" v-else-if="customer['readOnly'] === true">
        <v-btn color="primary" dense small v-if="editRequestStatus === 'none'" @click="editRequestDialog = true">
          <v-icon small left>mdi-account-edit</v-icon>
          Request Edit
        </v-btn>
        <v-chip color="warning" small v-else-if="editRequestStatus === 'pending'">
          <v-icon dense left>mdi-clock-outline</v-icon>
          Pending Edit
        </v-chip>
      </Row>
    </tbody>

    <v-dialog v-model="editRequestDialog" width="400">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Request Profile Edit</v-card-title>
        <v-card-text class="pt-4">
          <v-textarea
            v-model="narration"
            label="Narration"
            outlined
            rows="3"
            autofocus
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="editRequestDialog = false">Cancel</v-btn>
          <v-btn color="primary" text :disabled="!narration.trim()" @click="submitEditRequest">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-simple-table>
</template>

<script>
import lookups from '@/mixins/lookups';
import Row from "@/components/Row";
import Telephone from "@/components/Telephone";

export default {

  components: { Row, Telephone },

  props: {
    customer: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      editRequestStatus: 'loading',
      editRequestDialog: false,
      narration: '',
    }
  },

  methods: {
    reloadCustomers() {
      this.$store.dispatch('reloadAllCustomers');
    },
    submitEditRequest() {
      this.editRequestDialog = false;
      this.remoteLookup('ultimateTzRequestEditProfile', { uuid: this.customer.uuid, description: this.narration })
        .then(() => {
          this.narration = '';
          this.editRequestStatus = 'pending';
        })
        .catch(e => console.error(e));
    },
  },

  computed: {
    uuid() { return this.customer.uuid; },
  },

  mounted() {
    if (this.customer['readOnly'] === true) {
      this.remoteLookup('ultimateTzEditProfileStatus', { uuid: this.customer.uuid })
        .then(result => { this.editRequestStatus = result.pending ? 'pending' : 'none'; })
        .catch(() => { this.editRequestStatus = 'none'; });
    }
  },

  mixins: [lookups],

}
</script>
